<div class="flex flex-col min-h-0 h-full rounded-xl border border-slate-200 bg-white overflow-hidden">
  <!-- Envelope: what the inbox list shows. -->
  <div class="shrink-0 px-3 py-2 border-b border-slate-100 bg-slate-50/70">
    <div class="flex items-center justify-between gap-2">
      <p class="text-[11px] text-slate-500 truncate min-w-0">
        <span class="font-semibold text-slate-700">{{ preview?.from || '—' }}</span>
        <span class="text-slate-400"> → {{ preview?.to || '—' }}</span>
      </p>
      <div class="flex items-center gap-1 shrink-0">
        <i *ngIf="loading" class="fa-solid fa-circle-notch fa-spin text-[10px] text-slate-400"></i>
        <div *ngIf="!compact && preview?.html" class="flex rounded-md border border-slate-200 bg-white p-0.5">
          <button type="button" class="w-6 h-5 grid place-items-center rounded text-[10px]"
                  [ngClass]="device === 'desktop' ? 'bg-slate-800 text-white' : 'text-slate-400 hover:text-slate-700'"
                  (click)="device = 'desktop'" title="Desktop width"><i class="fa-solid fa-desktop"></i></button>
          <button type="button" class="w-6 h-5 grid place-items-center rounded text-[10px]"
                  [ngClass]="device === 'mobile' ? 'bg-slate-800 text-white' : 'text-slate-400 hover:text-slate-700'"
                  (click)="device = 'mobile'" title="Phone width"><i class="fa-solid fa-mobile-screen-button"></i></button>
        </div>
      </div>
    </div>
    <p class="mt-0.5 text-[13px] font-semibold text-slate-900 truncate">{{ preview?.subject || '(no subject)' }}</p>
    <p *ngIf="nameNote" class="mt-0.5 text-[10px] truncate"
       [ngClass]="preview?.firstName ? 'text-emerald-600' : 'text-amber-600'">{{ nameNote }}</p>
  </div>

  <p *ngIf="error" class="px-3 py-2 text-[11px] text-red-600 bg-red-50 border-b border-red-100">{{ error }}</p>

  <!-- Branded template: the real HTML, in a sandbox. -->
  <div *ngIf="preview?.html" class="flex-1 min-h-0 bg-[#f4f4f5] flex justify-center overflow-hidden"
       [class.max-h-[420px]]="compact">
    <iframe class="h-full border-0 bg-[#f4f4f5] transition-[width] duration-200"
            [style.width]="device === 'mobile' ? '375px' : '100%'"
            [style.minHeight]="compact ? '320px' : '520px'"
            sandbox="allow-popups allow-popups-to-escape-sandbox"
            [srcdoc]="html" title="Email preview"></iframe>
  </div>

  <!-- Plain text: shown the way a mail client shows a text-only message. -->
  <div *ngIf="preview && !preview.html" class="flex-1 min-h-0 overflow-auto px-4 py-3"
       [class.max-h-[420px]]="compact">
    <pre class="whitespace-pre-wrap break-words font-sans text-[13px] leading-relaxed text-slate-800">{{ preview.text }}</pre>
  </div>

  <div *ngIf="!preview && !error" class="flex-1 grid place-items-center py-16">
    <ion-spinner name="crescent"></ion-spinner>
  </div>
</div>
